import React from 'react'
import "./Idioma.css";
const Ingles = ({ handleEvent }) => {
    return <button className= "idioma" onClick={e => {
      localStorage.setItem("ingles",0)
      handleEvent(0)
    }}>ES | EN</button>;
  };
export default Ingles